import {extendConfig} from './extend-config';

export const config = extendConfig({
  datadog: {
    environment: `prod`,
    enabled: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    testTenants: JSON.parse(process.env.NEXT_PUBLIC_TEST_TENANTS || `[]`) as Array<string>,
  },
  nextauth: {
    invalidateWhenIdpSessionExpired: {
      '689a00783663ba31a467e4da': true, // SHL
    },
  },
});
